import React, { PropsWithChildren } from 'react';
import { styled } from 'styletron-react';

import { TechemTheme } from '@techem/techem-theme';
import arrowIcon from 'presentation/assets/icons/svg/arrow.svg';

interface Props {
  ariaLabel: string;
  additionalTestId?: string;
  handleClick: () => void;
}

const StyledRedLinkButtonWithArrow = styled('button', {
  background: 'none',
  padding: '0',
  border: 'none',
  color: TechemTheme.colors.primary,
  cursor: 'pointer',
  ':focus': {
    textDecoration: 'underline'
  },
  ':after': {
    content: `url(${arrowIcon})`,
    marginLeft: '5px'
  }
});

const RedLinkButtonWithArrow: React.FC<PropsWithChildren<Props>> = ({
  children,
  ariaLabel,
  handleClick,
  additionalTestId
}) => {
  return (
    <StyledRedLinkButtonWithArrow
      aria-label={ariaLabel}
      tabIndex={0}
      data-gi={`inline-link${additionalTestId ? ' ' + additionalTestId : ''}`}
      onClick={() => handleClick()}
    >
      <strong>{children}</strong>
    </StyledRedLinkButtonWithArrow>
  );
};

export default RedLinkButtonWithArrow;
